import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { openLogin } from '../redux/slices/authUiSlice';
import useAuth from '../hooks/useAuth';

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/', { replace: true });
      dispatch(openLogin()); // open modal
    }
  }, [isAuthenticated, dispatch, navigate]);

  // Render the background (current page) even if not authenticated
  return <>{children}</>;
}
